import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import compose from 'lodash.flowright';
import { mapProps } from 'recompose';

import CheckboxIcon from '../../../../../../../../components/icons/CheckboxIcon';
import Button from '../../../../../../../../components/global/Button';
import withModal from '../../../../../../../../components/global/modal/withModal';
import usePurchasesPendingConfiguration from '../hooks/usePurchasesPendingConfiguration';
import AlbumPrintPackageOptionList from './AlbumPrintPackageOptionList';
import ShoppingBasketIcon from '../../../../../../../../components/icons/ShoppingBasketIcon';

export const PURCHASED_PRINT_PACKAGE_CONFIGURATION_COMPLETE_MODAL =
  'modal/PURCHASED_PRINT_PACKAGE_CONFIGURATION_COMPLETE';

const propTypes = {
  hierarchyItemId: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func,
  onCheckout: PropTypes.func,
};

const PurchasedPrintPackageConfigurationCompleteModal = ({
  albumMembershipGroup,
  hierarchyItemId,
  className,
  onClose,
  onCheckout,
}) => {
  const {
    albumPrintPackages,
    prepaidPrintPackagesMissingConfiguration,
  } = usePurchasesPendingConfiguration({ hierarchyItemId });

  const classes = classNames({
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="d-flex align-items-center mb-2">
        <h3 className="w-100 text-center mb-0">Configuration Complete!</h3>
      </div>

      <div className="d-flex align-items-center">
        <span>
          <CheckboxIcon size={24} />
        </span>
        <p className="mb-0 ml-1">
          Your print package is ready for shipping and has been added to your
          cart.
        </p>
      </div>
      <Button
        btnBlock
        className="my-2 btn-checkout-print-product-size-success"
        btnStyle="success-vibrant"
        onClick={() => {
          onCheckout();
          onClose();
        }}
      >
        <ShoppingBasketIcon />
        Checkout
      </Button>
      <Button
        btnBlock
        btnOutline
        className="text-center mb-2"
        onClick={onClose}
      >
        Continue shopping
      </Button>
      {prepaidPrintPackagesMissingConfiguration?.length > 0 && (
        <Fragment>
          <p className="text-danger text-sm text-bold mb-3">
            NOTE: Additional shipping fees will be incurred for separate
            shipments. Configure your remaining purchases (
            {prepaidPrintPackagesMissingConfiguration.length}) and ship
            everything together to save on shipping fees!
          </p>
          <p className="text-light text-uppercase text-extra-bold text-sm">
            Configure your remaining purchases:
          </p>
          <AlbumPrintPackageOptionList
            albumMembershipGroup={albumMembershipGroup}
            prepaidPrintPackages={prepaidPrintPackagesMissingConfiguration}
            albumPrintPackages={albumPrintPackages}
            onCheckout={onCheckout}
          />
        </Fragment>
      )}
    </div>
  );
};

PurchasedPrintPackageConfigurationCompleteModal.propTypes = propTypes;

export default withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(PurchasedPrintPackageConfigurationCompleteModal),
  {
    name: PURCHASED_PRINT_PACKAGE_CONFIGURATION_COMPLETE_MODAL,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
  },
);
